<app-loading-swirly
  [isLoading]="!(currentQuoteInfo || currentWorkOrderInfo || workOrderHistoryInfo || quoteHistoryInfo)"></app-loading-swirly>
@if (currentQuoteInfo || currentWorkOrderInfo || workOrderHistoryInfo || quoteHistoryInfo) {
<p-accordion [value]="value" [multiple]="true">
  @if (quoteRequestInfo && quoteRequestInfo.quoteRequests && quoteRequestInfo.quoteRequests.length > 0) {
  <p-accordion-panel value="0">
    <p-accordion-header>FINALIZE FIRMTIME QUOTE REQUEST(S)</p-accordion-header>
    <p-accordion-content>
      @for (quote of quoteRequestInfo.quoteRequests; track quote) {
      <div>
        <app-customer-firmtime-quote-row [quote]="quote"></app-customer-firmtime-quote-row>
      </div>
      }
      <app-loading-swirly [isLoading]="quoteRequestsLoading"></app-loading-swirly>
      @if (quoteRequestInfo.quoteRequests.length) {
      <div style="text-align: center;">
        @if (quoteRequestInfo.quoteRequests.length < quoteRequestInfo.requestsTotal && !quoteRequestsLoading) { <div
          class="link" (click)="loadMoreUnfinalizedQuoteRequests()">Load more</div>
      }
      {{quoteRequestInfo.quoteRequests.length}} of {{quoteRequestInfo.requestsTotal}}
      </div>
      }
    </p-accordion-content>
  </p-accordion-panel>
  }
  @if (quoteRequestInfo && quoteRequestInfo.length > 0) {
  <hr class="smallDivider" />
  }
  <p-accordion-panel value="1">
    <p-accordion-header>NEW QUOTES</p-accordion-header>
    <p-accordion-content>
      <app-loading-swirly [isLoading]="!currentQuoteInfo"></app-loading-swirly>
      @if (currentQuoteInfo) {
      <span>
        @if (!currentQuoteInfo.quoteWorkOrders.length) {
        <div>
          You currently have no quotes to review.
        </div>
        }
        @for (quote of currentQuoteInfo.quoteWorkOrders; track quote) {
        <div>
          <app-customer-quote-row [quote]="quote" [current]="true"></app-customer-quote-row>
        </div>
        }
        <app-loading-swirly [isLoading]="currentQuoteLoading"></app-loading-swirly>
        @if (currentQuoteInfo.quoteWorkOrders.length) {
        <div style="text-align: center;">
          @if (currentQuoteInfo.quoteWorkOrders.length < currentQuoteInfo.quoteTotal && !currentQuoteLoading) { <div
            class="link" (click)="loadMoreCurrentQuote()">Load more</div>
        }
        {{currentQuoteInfo.quoteWorkOrders.length}} of {{currentQuoteInfo.quoteTotal}}
        </div>
        }
      </span>
      }</p-accordion-content>
  </p-accordion-panel>
  <hr class="smallDivider" />
  <p-accordion-panel value="2">
    <p-accordion-header>SCHEDULING</p-accordion-header>
    <p-accordion-content>
      <div class="fine-print">
        Tree Work, Tree Wellness, and Stump Grinding are performed by separate crews so we can most efficiently and
        effectively complete your work. Each service is auto charged to the credit card on file separately as the work
        is completed.
      </div>
      <br />
      <app-loading-swirly [isLoading]="!currentWorkOrders"></app-loading-swirly>
      @if (currentWorkOrders) {
      <span>
        @if (!currentWorkOrders.length) {
        <div>
          You currently have no outstanding work.
        </div>
        }
        @for (workOrder of currentWorkOrders; track workOrder) {
        <div>
          <app-customer-work-order-row [workOrder]="workOrder" [current]="true"></app-customer-work-order-row>
        </div>
        }
        <app-loading-swirly [isLoading]="currentWorkOrderLoading"></app-loading-swirly>
        @if (currentWorkOrders.length) {
        <div style="text-align: center;">
          @if (currentWorkOrders.length < currentWorkOrderInfo.workOrderTotal && !currentWorkOrderLoading) { <div
            class="link" (click)="loadMoreCurrentWorkOrders()">Load more</div>
        }
        {{currentWorkOrders.length}} of {{currentWorkOrderInfo.workOrderTotal}}
        </div>
        }
      </span>
      }
    </p-accordion-content>
  </p-accordion-panel>
  <hr class="smallDivider" />
  <p-accordion-panel value="3">
    <p-accordion-header>COMPLETED WORK</p-accordion-header>
    <p-accordion-content>
      <app-loading-swirly [isLoading]="!historicalWorkOrders"></app-loading-swirly>
      @if (historicalWorkOrders ) {
      <span>
        @if (!historicalWorkOrders.length && !historicalWorkOrders.length) {
        <div>
          You currently have no completed work.
        </div>
        }
        @for (workOrder of historicalWorkOrders; track workOrder) {
        <div>
          <app-customer-work-order-row [workOrder]="workOrder"
            [workOrderBilling]="getWorkOrderBillingByWorkOrder(workOrder)"
            [current]="false"></app-customer-work-order-row>
        </div>
        }
        <app-loading-swirly [isLoading]="historicalWorkOrderLoading"></app-loading-swirly>
        @if (historicalWorkOrders.length) {
        <div style="text-align: center;">
          @if (historicalWorkOrders.length < workOrderHistoryInfo.workOrderTotal && !historicalWorkOrderLoading) { <div
            class="link" (click)="loadMoreHistoricalWorkOrders()">Load more</div>
        }
        {{historicalWorkOrders.length}} of {{workOrderHistoryInfo.workOrderTotal}}
        </div>
        }
      </span>
      }</p-accordion-content>
  </p-accordion-panel>
  <hr class="smallDivider" />
  <p-accordion-panel value="4">
    <p-accordion-header>QUOTE HISTORY</p-accordion-header>
    <p-accordion-content>
      <app-loading-swirly [isLoading]="!quoteHistoryInfo"></app-loading-swirly>
      @if (quoteHistoryInfo) {
      <span>
        @if (!quoteHistoryInfo.quoteWorkOrders.length) {
        <div>
          You currently have no completed quotes.
        </div>
        }
        @for (quote of quoteHistoryInfo.quoteWorkOrders; track quote) {
        <div>
          <app-customer-quote-row [quote]="quote" [current]="false"></app-customer-quote-row>
        </div>
        }
        <app-loading-swirly [isLoading]="quoteHistoryLoading"></app-loading-swirly>
        @if (quoteHistoryInfo.quoteWorkOrders.length) {
        <div style="text-align: center;">
          @if (quoteHistoryInfo.quoteWorkOrders.length < quoteHistoryInfo.quoteTotal && !quoteHistoryLoading) { <div
            class="link" (click)="loadMoreQuoteHistory()">Load more</div>
        }
        {{quoteHistoryInfo.quoteWorkOrders.length}} of {{quoteHistoryInfo.quoteTotal}}
        </div>
        }
      </span>
      }</p-accordion-content>
  </p-accordion-panel>
  <hr class="smallDivider" />
</p-accordion>
}